import { Redirect, useLocalSearchParams } from 'expo-router';

import { CardModal } from 'components/card-modal';
import { routes } from 'navigation/routing';
import LoyaltyBadgeDetails from 'pages/loyalty/loyalty-badges/loyalty-badge-detail';
import { useGetLoyaltyBadges } from 'pages/loyalty/loyalty-badges/use-get-loyalty-badges';
import LoyaltyLoader from 'pages/loyalty/loyalty-loader/loyalty-loader';
import { stringToBool } from 'utils/string-To-Bool';

export default function BadgeDetail() {
  const queryParams = useLocalSearchParams<{
    justEarned: string;
    badgeId: string;
  }>();
  const badgeId = queryParams.badgeId;
  const justEarned = !!stringToBool(queryParams.justEarned);
  const { badges, loading, error } = useGetLoyaltyBadges();

  if (loading || (!error && !badges)) {
    return (
      <CardModal alwaysShowHeader isLoading disableGlobalAppModals>
        <LoyaltyLoader />
      </CardModal>
    );
  }

  const selectedBadge = badges?.find(badge => badge.id === badgeId);

  if (!selectedBadge) {
    return <Redirect href={routes.rewardsProfile} />;
  }

  return <LoyaltyBadgeDetails badge={selectedBadge} showCelebration={justEarned} />;
}
